import { Component, Input } from '@angular/core';

import { GridData, CellComponent, CellContext } from '@grid/models';

@Component({
  selector: 'app-not-applicable',
  template: `<span
    [attr.data-testId]="
      'display-' + context.column.header.name + '-' + context.row.index
    "
    i18n="@@shared.notApplicative.txtN/A"
    >N/A</span
  >`,
})
export class NotApplicableDisplayComponent implements CellComponent<GridData> {
  @Input({ required: true }) context!: CellContext<GridData>;
}
